import { http } from "@/shared/lib/api/http";

export type RegisterPushSubscriptionInput = {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  deviceLabel?: string;
};

/** Register (or re-activate) this device's push subscription with the backend. */
export async function registerPushSubscription(input: RegisterPushSubscriptionInput) {
  const response = await http.post<{ id: string | null }>("/push/subscriptions", input);
  return response.data;
}

/**
 * Deactivate this device's push subscription on the backend (this device only).
 * Used both by the preferences toggle and the sign-out flow.
 */
export async function deactivatePushSubscription(endpoint: string) {
  const response = await http.delete<{ deactivated: number }>("/push/subscriptions", {
    data: { endpoint },
  });
  return response.data;
}

/** Fetch the server VAPID public key (fallback when VITE_VAPID_PUBLIC_KEY is not set). */
export async function getPushPublicKey() {
  const response = await http.get<{ publicKey: string | null }>("/push/public-key");
  return response.data.publicKey;
}
